"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shallow_1 = require("zustand/shallow");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const SmallToggleSwitchPurple_1 = __importDefault(require("components/shared/ToogleSwitch/SmallToggleSwitchPurple"));
const ToggleWeight = ({ objective, usingWeight, isAllowToUpdate, isLocked, index }) => {
    const { handleToggleWeight, isPercentage } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        handleToggleWeight: state.handleToggleWeight,
        isPercentage: state.isPercentage
    }), shallow_1.shallow);
    return (react_1.default.createElement(SmallToggleSwitchPurple_1.default, { idStr: `use-weight-${index}`, dataCy: `use-weight-${index}`, isChecked: usingWeight, disabled: !isAllowToUpdate || (isPercentage ? false : isLocked), onChange: () => handleToggleWeight(objective?.id), addClass: "flex items-center ml-[-12px] mr-[2px]" }));
};
exports.default = ToggleWeight;
